import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Dispatch, DispatchStats, Program, UIDispatch} from '../../domain/cloud-topology';
import {ResourceService} from '../resource.service';
import {dispatchStatusUrl, dispatchUrl, programUrl, UTC_TIMEZONE} from '../../domain/constants';
import {AuthGuardService} from '../auth-guard.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ProgramService} from './program.service';
import {environment} from "../../../environments/environment";
@Injectable({
  providedIn: 'root'
})
export class DispatchService {
  constructor(private http: HttpClient, private programService: ProgramService) {}

  getProgramDispatches(program: Program, timezone?: string, includes?: string[], excludes?: string[]): Observable<Dispatch[]> {
    let params =  new HttpParams();
    if (includes) {
      params = params.append('includes',  includes.join(','));
    }

    if (excludes) {
      params = params.append('excludes', excludes.join(','));
    }

    return this.http.get(ResourceService.buildUrl([environment.vppUrl, programUrl, program.id, dispatchUrl]), {
      params: params
    }).pipe(map(dispatches => {
      let convertedDispatches = [];
      for (const dispatch of dispatches['data']) {
        if (timezone != UTC_TIMEZONE) {
          convertedDispatches.push(UIDispatch.convertFromUtc(dispatch, timezone));
        } else {
          convertedDispatches.push(dispatch);
        }
      }

      return convertedDispatches;
    }));
  }

  getActiveDispatch(program: Program): Observable<Dispatch> {
    return this.http.get(ResourceService.buildUrl([environment.vppUrl, programUrl, program.id, dispatchUrl]), {
      params: new HttpParams().set('includes', 'ACTIVE')
    }).pipe(map(res => res['data']));
  }

  postProgramDispatch(program: Program, dispatch?: Dispatch, timezone?: string): Observable<Dispatch> {
    dispatch = UIDispatch.convertToUtc(dispatch);

    return this.http.post(ResourceService.buildUrl([environment.vppUrl, programUrl, program.id, dispatchUrl]), {
      setpoint: dispatch.setpoint,
      penalty: dispatch.penalty,
      type: dispatch.type,
      duration: dispatch.duration,
      targetId: program.id,
      incentive: dispatch.incentive,
      startTimeUtc: dispatch.startTimeUtc,
      properties: {},
    }).pipe(map(dispatchh => {
      return timezone ? UIDispatch.convertFromUtc(dispatchh['data'], timezone) : dispatchh['data'];
    }));
  }

  putProgramDispatch(program: Program, dispatch: Dispatch, timezone?: string): Observable<Dispatch> {
    dispatch = UIDispatch.convertToUtc(dispatch);
    return this.http.put(ResourceService.buildUrl([environment.vppUrl, programUrl, program.id, dispatchUrl]), dispatch, {
      params: new HttpParams().set('dispId', dispatch.id)
    }).pipe(map(dispatch => {
      return UIDispatch.convertFromUtc(dispatch['data'], timezone);
    }));
  }

  deleteProgramDispatch(program: Program, dispatch: Dispatch) {
    return this.http.delete(ResourceService.buildUrl([environment.vppUrl, programUrl, program.id, dispatchUrl]), {
      params: new HttpParams().set('dispId', dispatch.id),
      responseType: 'text',
    }).pipe(map(res => res['data']));
  }

  getDispatchStatus(dispatch: Dispatch): Observable<DispatchStats>{
    return this.http.get(ResourceService.buildUrl([environment.vppUrl, programUrl, dispatchStatusUrl, dispatch.id])).pipe(map(res => res['data']));
  }
}
